<template>
  <div class="width-100 min-height container">
    <img src="../../assets/image/msjd/3_01.jpg" width="100%" alt="" />
    <div class="form-box width-100 padding-90">
      <div class="yellow-box">
        <div class="white-box">
          <van-form @submit="onSubmit">
            <van-field
              v-if="checked"
              v-model="form.name"
              name="姓名"
              placeholder="您的姓名"
              :rules="[{ required: true, message: '请输入您的姓名' }]"
            />
            <van-field
              v-model="form.mobile"
              name="手机号码"
              placeholder="手机号码"
              type="number"
              :rules="[{ validator: mobileValidator, message: '请填写正确的手机号码' }]"
            />
            <van-field
              v-model="form.vcode"
              center
              clearable
              name="验证码"
              type="number"
              placeholder="验证码"
              :rules="[{ required: true, message: '请输入验证码' }]"
            >
              <template #button>
                <van-button class="send-code" size="small" type="primary" @click="sendSms" native-type="button">{{ htmlText }}</van-button>
              </template>
            </van-field>
            <van-field
              v-if="checked"
              v-model="form.deptName"
              name="投诉人所在企业"
              placeholder="投诉人所在企业"
              :rules="[{ required: true, message: '请输入投诉人所在企业' }]"
            />
            <van-field v-else v-model="form.deptName" name="投诉人所在企业" placeholder="投诉人所在企业(选填)" />
            <van-field
              readonly
              clickable
              name="投诉时间"
              :value="form.complaintTime"
              placeholder="投诉时间"
              right-icon="arrow-down"
              @click="showPicker = true"
              :rules="[{ required: true, message: '请选择投诉时间' }]"
            />
            <van-popup v-model="showPicker" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                title="选择完整时间"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="onConfirm"
                @cancel="showPicker = false"
              />
            </van-popup>
            <van-field
              v-model="form.complaintDeptName"
              name="被投诉镇街或部门"
              placeholder="被投诉镇街或部门（科室站所）"
              :rules="[{ required: true, message: '请输入被投诉镇街或部门' }]"
            />
            <van-field
              v-model="form.content"
              rows="3"
              autosize
              type="textarea"
              name="投诉详细内容"
              placeholder="投诉详细内容"
              :rules="[{ required: true, message: '请输入投诉详细内容' }]"
            />

            <van-field v-model="form.replyMethod" name="回复方式" placeholder="回复方式（选填）" />
            <van-uploader v-model="picture" :before-read="beforeRead" :after-read="afterRead" :max-count="6" accept="image/*,video/*">
              <template #preview-cover="{ file }">
                <video
                  v-if="file && file.type.indexOf('video') != -1"
                  :src="file.url"
                  style="object-fit: fill; width: 100%; height: 100%"
                  @click="handlePreview(file)"
                  @canplay="canplay"
                ></video>
                <van-icon
                  v-if="file && file.type.indexOf('video') != -1 && playiconshow"
                  @click="handlePreview(file)"
                  name="play-circle"
                  size="40px"
                  color="#ffffff"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
                />
              </template>
            </van-uploader>
            <p class="black fs-mid opacity-5">附件（图片/视频）</p>

            <van-overlay :show="uploadshow" @click="uploadshow = false">
              <div class="wrapper">
                <div class="img-block">
                  <video autoplay class="video" :src="videourl" controls></video>
                </div>
                <!--给视频添加关闭图标-->
              </div>
              <van-icon name="clear" size="30px" class="video-delete" @click="uploadshow = false" />
            </van-overlay>
            <div class="button-box position-relative">
              <van-button class="width-100 position-absolute opacity-0" round block type="info" native-type="submit">提交</van-button>
              <img src="../../assets/image/msjd/3.png" width="100%" alt="" />
            </div>
          </van-form>
        </div>
      </div>
    </div>
    <p class="fs-sml white textAlign-c opacity-5">中共瑞安市纪律检查委员会</p>
  </div>
</template>
<script>
import { Notify, Toast } from 'vant';
import { sms, superviseSave } from '@/api/qflwApi';
import { imageUpload } from '@/api/msxcApi';
import { compressImg } from '@/utils/fileUtils';

export default {
  name: 'msjdForm',
  data() {
    return {
      checked: false,
      form: {
        name: '',
        mobile: '',
        vcode: '',
        deptName: '',
        complaintDeptName: '',
        complaintTime: '',
        content: '',
        type: '',
        replyMethod: '',
        file: ''
      },
      picture: [],
      isSend: false,
      timer: 0,
      timerId: '',
      htmlText: '发送验证码',

      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      showPicker: false,

      uploadshow: false,
      videourl: '',
      playiconshow: false
    };
  },
  created() {
    if (this.$route.query.t == '1') {
      this.checked = false;
    } else {
      this.checked = true;
    }
    this.form.type = this.$route.query.type;
  },
  methods: {
    handlePreview(file) {
      if (file.type.indexOf('video') != -1) {
        this.uploadshow = true;
        this.$nextTick(() => {
          this.videourl = file.url;
        });
      }
    },
    canplay() {
      this.playiconshow = true;
    },
    onConfirm(date) {
      this.form.complaintTime =
        date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes();
      this.showPicker = false;
    },
    mobileValidator(val) {
      return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(val);
    },
    timerGo() {
      if (this.timer <= 0) {
        this.htmlText = '发送验证码';
        clearInterval(this.timerId);
      } else {
        this.timer = this.timer - 1;
        this.htmlText = this.timer + '后重新发送';
      }
    },
    sendSms() {
      if (!this.mobileValidator(this.form.mobile)) {
        Notify({ type: 'danger', message: '请输入正确的手机号' });
      } else {
        if (this.timer <= 0 && !this.isSend) {
          this.isSend = true;
          sms(this.form.mobile).then((res) => {
            if (res.code === 200) {
              Notify({ type: 'success', message: '短信发送成功' });
              this.timer = 60;
              this.timerId = setInterval(this.timerGo, 1000);
            } else {
              Notify({ type: 'danger', message: '短信发送失败' });
            }
            this.isSend = false;
          });
        }
      }
    },
    onSubmit() {
      this.form.file = '';
      this.picture.forEach((item) => {
        let imgUrl = item.file ? item.file.url : item.url;
        if (this.form.file === '') {
          this.form.file += imgUrl;
        } else {
          this.form.file += ',' + imgUrl;
        }
      });
      superviseSave(this.form, this.form.vcode).then((res) => {
        if (res.code === 200) {
          Notify({ type: 'success', message: '提交成功' });
          this.$router.back();
        } else {
          Notify({ type: 'danger', message: '提交失败' });
        }
      });
    },
    beforeRead(file) {
      return new Promise((resolve, reject) => {
        if (!(file.type.indexOf('video') != -1 || file.type.indexOf('image') != -1)) {
          Notify({ type: 'danger', message: '只允许传图片或视频' });
          reject();
        }
        if (file.type.indexOf('image') != -1) {
          //压缩
          compressImg(file).then((f) => {
            resolve(f);
          });
        } else {
          resolve(file);
        }
      });
    },
    afterRead(file) {
      let toast = Toast.loading({
        duration: 0,
        message: '上传文件中...',
        forbidClick: true,
        loadingType: 'spinner'
      });
      let formData = new FormData();
      if (file.constructor != Array) {
        if (file.file.type.indexOf('image') != -1) {
          formData.append('files', file.file, 'image' + file.file.name);
        } else if (file.file.type.indexOf('video') != -1) {
          formData.append('files', file.file, 'video' + file.file.name);
        }
      } else {
        file.forEach((element) => {
          if (element.file.type.indexOf('image') != -1) {
            formData.append('files', element.file, 'image' + element.file.name);
          } else if (element.file.type.indexOf('video') != -1) {
            formData.append('files', element.file, 'video' + element.file.name);
          }
        });
      }
      imageUpload(formData).then((res) => {
        if (res.code === 200) {
          if (file.constructor != Array) {
            file.file.url = res.urls;
          } else {
            let urlArr = res.urls.split(',');
            let nameArr = res.originalFilenames.split(',');
            file.forEach((element) => {
              for (let i = 0; i < nameArr.length; i++) {
                if (element.file.name === nameArr[i]) {
                  element.file.url = urlArr[i];
                  break;
                }
              }
            });
          }
        } else {
          Notify({ type: 'danger', message: '附件添加失败' });
        }
        toast.clear();
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/css/common.css';
@import '../../assets/css/demo1.css';
@import '../../assets/css/demo2.css';
.container {
  background: #ae231b;
  padding-bottom: 50px;
  .form-box {
    margin-bottom: 10px;
    .yellow-box {
      padding: 5px;
      background: linear-gradient(to top, #fffdec, #ffbd8c);
      border-radius: 10px;
      .white-box {
        width: 100%;
        padding: 30px 5% 50px;
        background: white;
        border-radius: 10px;
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
        /deep/.van-button--primary {
          background: rgba(255, 255, 255) !important;
          border: none;
          color: orangered;
        }
        /deep/.van-button__text {
          font-size: 14px !important;
        }
        /deep/.van-button::before {
          background: rgba(255, 255, 255) !important;
        }
        /deep/.van-cell::after {
          border-bottom: none;
        }
        /deep/.van-field__control::placeholder {
          color: #333333 !important;
        }
        /deep/.van-cell {
          border: 1px solid #cccccc;
          border-radius: 5px;
          margin-bottom: 15px;
          padding: 8px 16px;
        }
        .button-box {
          margin: 40px 25% 0px;
        }
        /deep/.van-uploader__upload {
          background: rgba(255, 255, 255) !important;
          border: 1px solid #cccccc;
          border-radius: 5px;
        }
      }
    }
  }
}

img {
  vertical-align: middle;
}

.wrapper {
  display: Flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.img-block {
  position: relative;

  img {
    z-index: 99;
    max-width: 100%;
    height: auto;
    object-fit: cover;
  }

  video {
    width: 100%;
    max-height: 100vh;
  }
}

.video-delete {
  position: absolute;
  top: 20px;
  left: calc(100vw - 40px);
}

.uploader {
  background-color: rgba(0, 0, 0, 0);

  /deep/ .van-uploader__upload {
    background-color: #ffffff;
  }
}
</style>
